export default {
  SET_IS_MOBILE: (state, payload) => {
    state.isMobile = payload
  },
  SET_IS_SMALL_MOBILE: (state, payload) => {
    state.isSmallMobile = payload
  },
  SET_IS_EXTRA_SMALL_MOBILE: (state, payload) => {
    state.isExtraSmallMobile = payload
  },
  SET_ADHD_FOCUS: (state, payload) => {
    state.isAdhdFocusActive = payload
  }
}
